export const normalizePlaceCode = (value: any): string =>
  String(value || '').trim().toUpperCase();

export const isCancelledRegistrationStatus = (value: any): boolean =>
  String(value || '').trim().toLowerCase() === 'cancelled';

export const getRegistrationPlaceCode = (data: any): string => {
  const assignedAccommodation =
    data?.financial?.assignedAccommodation || data?.assignedAccommodation || data?.accommodationFees;
  const rawPlaceCode =
    data?.financial?.accommodationFees?.assignedAccommodation ||
    assignedAccommodation?.placeCode ||
    data?.financial?.accommodationFees?.priceCode;

  return normalizePlaceCode(rawPlaceCode);
};

export const getRegistrationPlaceName = (data: any): string => {
  const assignedAccommodation =
    data?.financial?.assignedAccommodation || data?.assignedAccommodation || data?.accommodationFees;
  const placeCode = getRegistrationPlaceCode(data);

  return assignedAccommodation?.placeName || data?.financial?.accommodationFees?.placeName || placeCode;
};
